import { forwardRef } from "react";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { Form } from "@shared/components/Form";
import { getCategorysService } from "@modules/categorys/services/queries/listCategorys/service";

export const CategoriesAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={getCategorysService} />
  );
});

CategoriesAutocomplete.displayName = "CategoriesAutocomplete";
